/**
 * Listing composer (staff, step 11) and the public listings read shape.
 *
 * Brought in line with every other domain's own schema file (Conventions:
 * "zod at the boundary, schemas in packages/shared") — the toggle-only
 * routes this module started with validated inline, but the composer's
 * fields are shared with the frontend form, which is what this file is for.
 */
import { z } from 'zod';
import { nonNegativeMoneySchema } from '../money.js';
import { optionalText } from './common.js';
export const updateListingDetailsSchema = z.object({
    description: optionalText(2000),
    // Not nullish: publishUnit always seeds this from unit.marketRent, and the
    // public read path has no live fallback to null back to (no policy on
    // `units` to read marketRent through) — so the composer may change the
    // value or leave it alone, never clear it.
    advertisedRent: nonNegativeMoneySchema.optional(),
});
/** Used for both the featured photo and gallery photos — same two-step shape. */
export const startListingPhotoUploadSchema = z.object({
    contentType: z.string().trim().min(1).max(128),
    sizeBytes: z.coerce.number().int().positive(),
});
export const confirmListingPhotoSchema = z.object({
    storageKey: z.string().trim().min(1).max(1024),
});
//# sourceMappingURL=listing.js.map